var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',_vm._b({staticClass:"btn",attrs:{"loading-text":"Processing...","round":"","size":"small"}},'van-button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }